import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { OfferCreate, OfferDetail } from 'types/api'
import { BaseParams } from 'types/utils'

export function useCreateOffer() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError() // Added useOnError

  async function createOffer({
    body
  }: BaseParams<[OfferCreate, OfferDetail[]], 'POST'>) {
    const res = await apiClient.post<OfferDetail[]>(
      `${SNA_PREFIX}offers/`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: createOffer,
    onSuccess: (data, variables) => {
      variables?.params?.onSuccess?.(data)
      toast.success({ message: t('offerCreated') })
      queryClient.invalidateQueries({ queryKey: ['offers', 'offers-detail'] })
    },
    onError // Updated to use useOnError
  })
}
